import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "member-table-container"
}
const _hoisted_3 = { class: "table-header" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "file-upload-area" }
const _hoisted_6 = {
  key: 0,
  class: "file-preview"
}
const _hoisted_7 = { class: "member-search-filter" }
const _hoisted_8 = { class: "table-wrapper" }
const _hoisted_9 = { class: "header-content" }
const _hoisted_10 = { class: "header-content" }
const _hoisted_11 = { class: "header-content" }
const _hoisted_12 = { class: "header-content" }
const _hoisted_13 = { class: "header-content" }
const _hoisted_14 = { class: "comparison-summary" }
const _hoisted_15 = { class: "smart-comparison-table" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "status-cell" }
const _hoisted_18 = {
  key: 0,
  class: "change-indicator"
}
const _hoisted_19 = { class: "old-value" }
const _hoisted_20 = { class: "new-value" }
const _hoisted_21 = {
  key: 0,
  class: "change-indicator"
}
const _hoisted_22 = { class: "old-value" }
const _hoisted_23 = { class: "new-value" }
const _hoisted_24 = {
  key: 0,
  class: "change-indicator"
}
const _hoisted_25 = { class: "old-value" }
const _hoisted_26 = { class: "new-value" }
const _hoisted_27 = {
  key: 0,
  class: "change-indicator"
}
const _hoisted_28 = { class: "old-value" }
const _hoisted_29 = { class: "new-value" }
const _hoisted_30 = {
  key: 0,
  class: "change-indicator"
}
const _hoisted_31 = { class: "old-value" }
const _hoisted_32 = { class: "new-value" }

import { ref, watch } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';


export default /*@__PURE__*/_defineComponent({
  __name: 'MemberUploadModal',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "uploaded"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const store = useStore();

// 상태 관리
const isUploadingMember = ref(false);
const loadingText = ref('업로드 중...');
const memberFile = ref<File | null>(null);
const memberTableData = ref<any[]>([]);
const filteredMemberData = ref<any[]>([]);
const memberSearchFilter = ref('');
const excludeResigned = ref(false);
const memberSortState = ref({
  column: '',
  direction: 'asc' as 'asc' | 'desc'
});

// 비교 모달
const showComparisonDialog = ref(false);
const comparisonData = ref<{
  comparison: any[];
  summary: {
    total: number;
    added: number;
    deleted: number;
    modified: number;
    unchanged: number;
  };
}>({
  comparison: [],
  summary: {
    total: 0,
    added: 0,
    deleted: 0,
    modified: 0,
    unchanged: 0
  }
});

// 스낵바 표시
const showSnackbar = (text: string, color: string = 'success') => {
  const timeout = color === 'error' && text.length > 100 ? 8000 : 4000;
  store.commit('showSnackbar', { text, color, timeout });
};

// 요양보호사 데이터 조회
const fetchMemberData = async () => {
  const user = store.state.user;
  if (!user || !user.m_sisul_code) {
    console.warn('사용자 정보가 없습니다.');
    return;
  }

  try {
    const response = await axios.get(`/api/files/member-data/${user.m_sisul_code}`, {
      withCredentials: true
    });

    if (response.data.success) {
      memberTableData.value = response.data.data || [];
      filteredMemberData.value = [...memberTableData.value];
    } else {
      memberTableData.value = [];
      filteredMemberData.value = [];
    }
  } catch (error) {
    console.error('요양보호사 데이터 조회 오류:', error);
    memberTableData.value = [];
    filteredMemberData.value = [];
  }
};

// 파일 선택 핸들러
const onMemberFileSelect = async (files: File[]) => {
  const file = files[0];
  if (file) {
    memberFile.value = file;
    
    const user = store.state.user;
    if (!user || !user.m_sisul_code) {
      showSnackbar('사용자 정보를 찾을 수 없습니다.', 'error');
      return;
    }
    
    try {
      isUploadingMember.value = true;
      loadingText.value = '요양보호사 파일을 분석하는 중...';
      
      const formData = new FormData();
      formData.append('file', file);
      formData.append('institutionCode', user.m_sisul_code);
      
      const response = await axios.post('/api/files/member-preview', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
        withCredentials: true
      });
      
      if (response.data.success) {
        comparisonData.value = response.data.data;
        showComparisonDialog.value = true;
      } else {
        showSnackbar(response.data.message || '파일 분석에 실패했습니다.', 'error');
      }
    } catch (error: any) {
      console.error('파일 분석 오류:', error);
      if (error.response?.data?.message) {
        showSnackbar(error.response.data.message, 'error');
      } else {
        showSnackbar('파일 분석 중 오류가 발생했습니다.', 'error');
      }
    } finally {
      isUploadingMember.value = false;
    }
  }
};

// 업로드 확인
const confirmUpload = async () => {
  showComparisonDialog.value = false;
  await uploadMemberFile();
};

// 업로드 취소
const cancelUpload = () => {
  showComparisonDialog.value = false;
  memberFile.value = null;
  comparisonData.value = {
    comparison: [],
    summary: {
      total: 0,
      added: 0,
      deleted: 0,
      modified: 0,
      unchanged: 0
    }
  };
};

// 사원 정보 업로드
const uploadMemberFile = async () => {
  if (!memberFile.value) return;
  
  const user = store.state.user;
  if (!user || !user.m_sisul_code) {
    showSnackbar('사용자 정보를 찾을 수 없습니다.', 'error');
    return;
  }
  
  try {
    isUploadingMember.value = true;
    loadingText.value = '요양보호사 정보를 업로드하는 중...';
    
    const formData = new FormData();
    formData.append('file', memberFile.value);
    formData.append('institutionCode', user.m_sisul_code);
    
    const response = await axios.post('/api/files/member-upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      withCredentials: true
    });
    
    if (response.data.success) {
      showSnackbar(response.data.message, 'success');
      await fetchMemberData();
      memberFile.value = null;
      emit('uploaded');
    } else {
      showSnackbar(response.data.message || '업로드에 실패했습니다.', 'error');
    }
  } catch (error: any) {
    console.error('사원 정보 업로드 오류:', error);
    if (error.response?.data?.message) {
      showSnackbar(error.response.data.message, 'error');
    } else {
      showSnackbar('업로드 중 오류가 발생했습니다.', 'error');
    }
  } finally {
    isUploadingMember.value = false;
  }
};

// 요양보호사 데이터 필터링
const filterMemberData = () => {
  let filtered = [...memberTableData.value];
  
  if (memberSearchFilter.value) {
    filtered = filtered.filter((member: any) => 
      member.name && 
      member.name.toString().toLowerCase().includes(memberSearchFilter.value.toLowerCase())
    );
  }
  
  if (excludeResigned.value) {
    filtered = filtered.filter((member: any) => {
      const endDate = splitDateRange(member.workPeriod).endDate;
      return !endDate || endDate === '' || endDate === '-';
    });
  }
  
  filteredMemberData.value = filtered;
};

// 요양보호사 데이터 정렬
const sortMemberData = (column: string) => {
  if (memberSortState.value.column === column) {
    memberSortState.value.direction = memberSortState.value.direction === 'asc' ? 'desc' : 'asc';
  } else {
    memberSortState.value.column = column;
    memberSortState.value.direction = 'asc';
  }
  
  filteredMemberData.value.sort((a: any, b: any) => {
    let aValue, bValue;
    
    if (column === 'workPeriod') {
      aValue = splitDateRange(a.workPeriod).startDate || '';
      bValue = splitDateRange(b.workPeriod).startDate || '';
    } else {
      aValue = a[column] || '';
      bValue = b[column] || '';
    }
    
    if (column === 'birthDate' || column === 'workPeriod') {
      const aDate = new Date(aValue);
      const bDate = new Date(bValue);
      if (!isNaN(aDate.getTime()) && !isNaN(bDate.getTime())) {
        return memberSortState.value.direction === 'asc' 
          ? aDate.getTime() - bDate.getTime()
          : bDate.getTime() - aDate.getTime();
      }
    }
    
    if (!isNaN(Number(aValue)) && !isNaN(Number(bValue))) {
      return memberSortState.value.direction === 'asc' 
        ? Number(aValue) - Number(bValue)
        : Number(bValue) - Number(aValue);
    }
    
    const comparison = aValue.toString().localeCompare(bValue.toString());
    return memberSortState.value.direction === 'asc' ? comparison : -comparison;
  });
};

// 날짜 범위 분리
const splitDateRange = (dateRange: string) => {
  let [startDate, endDate] = dateRange.split("~").map(s => s.trim());
  if (endDate === '9999-12-31') {
    endDate = '';
  }
  return { startDate, endDate };
};

// 파일 크기 포맷팅
const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return '0 Bytes';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

// 업로드 날짜 포맷팅
const formatUploadDate = (dateString: string): string => {
  if (!dateString) return '-';
  const date = new Date(dateString);
  return date.toLocaleDateString('ko-KR', {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

// 상태별 색상 반환
const getStatusColor = (status: string): string => {
  const colors: Record<string, string> = {
    added: 'success',
    modified: 'warning', 
    deleted: 'error',
    unchanged: 'info'
  };
  return colors[status] || 'grey';
};

// 상태별 아이콘 반환
const getStatusIcon = (status: string): string => {
  const icons: Record<string, string> = {
    added: 'mdi-plus-circle',
    modified: 'mdi-pencil',
    deleted: 'mdi-minus-circle',
    unchanged: 'mdi-check-circle'
  };
  return icons[status] || 'mdi-help-circle';
};

// 상태별 텍스트 반환
const getStatusText = (status: string): string => {
  const texts: Record<string, string> = {
    added: '추가',
    modified: '수정',
    deleted: '삭제',
    unchanged: '변경없음'
  };
  return texts[status] || '알수없음';
};

// 다이얼로그 닫기
const closeDialog = () => {
  emit('update:modelValue', false);
  memberFile.value = null;
  memberSearchFilter.value = '';
  excludeResigned.value = false;
  memberSortState.value = { column: '', direction: 'asc' };
  filteredMemberData.value = [...memberTableData.value];
};

// 모달이 열릴 때 데이터 조회
watch(() => props.modelValue, async (newValue) => {
  if (newValue) {
    await fetchMemberData();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_LodingComponent = _resolveComponent("LodingComponent")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_file_input = _resolveComponent("v-file-input")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_dialog, {
      "model-value": __props.modelValue,
      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('update:modelValue', $event))),
      "max-width": "900px",
      "content-class": "member-upload-dialog-wrapper"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "member-upload-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_LodingComponent, {
              "is-visible": isUploadingMember.value,
              text: loadingText.value
            }, null, 8, ["is-visible", "text"]),
            _createVNode(_component_v_card_title, { class: "member-upload-header" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  color: "white",
                  class: "mr-2"
                }, {
                  default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                    _createTextVNode("mdi-account-group", -1)
                  ]))]),
                  _: 1
                }),
                _cache[12] || (_cache[12] = _createTextVNode(" 사원 정보 업로드 ", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "member-upload-content" }, {
              default: _withCtx(() => [
                (memberTableData.value.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                      _createVNode(_component_v_file_input, {
                        modelValue: memberFile.value,
                        "onUpdate:modelValue": [
                          _cache[0] || (_cache[0] = ($event: any) => ((memberFile).value = $event)),
                          onMemberFileSelect
                        ],
                        accept: ".xls,.xlsx",
                        label: "엑셀 파일을 선택하세요",
                        variant: "outlined",
                        "prepend-icon": "mdi-file-excel",
                        density: "compact",
                        "hide-details": ""
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                (memberTableData.value.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("h3", null, [
                          _createTextVNode("엑셀업로드로 등록된 사원: " + _toDisplayString(filteredMemberData.value.length) + "명 ", 1),
                          (memberTableData.value[0]?.uploadDate)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_4, " 마지막업로드: " + _toDisplayString(formatUploadDate(memberTableData.value[0].uploadDate)), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("div", _hoisted_5, [
                          _createVNode(_component_v_file_input, {
                            modelValue: memberFile.value,
                            "onUpdate:modelValue": [
                              _cache[1] || (_cache[1] = ($event: any) => ((memberFile).value = $event)),
                              onMemberFileSelect
                            ],
                            accept: ".xls,.xlsx",
                            label: "엑셀 업로드",
                            variant: "outlined",
                            "prepend-icon": "mdi-file-excel",
                            density: "compact",
                            "hide-details": ""
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      (memberFile.value)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                            _createVNode(_component_v_chip, {
                              color: "#1e3a8a",
                              variant: "tonal",
                              size: "small"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, { start: "" }, {
                                  default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                    _createTextVNode("mdi-check-circle", -1)
                                  ]))]),
                                  _: 1
                                }),
                                _createTextVNode(" " + _toDisplayString(memberFile.value.name) + " (" + _toDisplayString(formatFileSize(memberFile.value.size)) + ") ", 1)
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_7, [
                        _createVNode(_component_v_text_field, {
                          modelValue: memberSearchFilter.value,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((memberSearchFilter).value = $event)),
                          onInput: filterMemberData,
                          label: "성명 검색",
                          variant: "outlined",
                          density: "compact",
                          "prepend-inner-icon": "mdi-account-search",
                          clearable: "",
                          class: "member-search-input",
                          "hide-details": "",
                          width: "150px"
                        }, null, 8, ["modelValue"]),
                        _createVNode(_component_v_checkbox, {
                          modelValue: excludeResigned.value,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((excludeResigned).value = $event)),
                          onChange: filterMemberData,
                          label: "퇴사자 제외",
                          density: "compact",
                          "hide-details": "",
                          class: "exclude-resigned-checkbox"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_v_table, {
                          class: "member-table",
                          "fixed-header": ""
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("thead", null, [
                              _createElementVNode("tr", null, [
                                _createElementVNode("th", {
                                  class: "sortable-header",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (sortMemberData('name')))
                                }, [
                                  _createElementVNode("div", _hoisted_9, [
                                    _cache[15] || (_cache[15] = _createElementVNode("span", null, "성명", -1)),
                                    (memberSortState.value.column === 'name')
                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 0,
                                          size: "small",
                                          class: "sort-icon"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(memberSortState.value.direction === 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down'), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 1,
                                          size: "small",
                                          class: "sort-icon inactive"
                                        }, {
                                          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                                            _createTextVNode(" mdi-unfold-more-horizontal ", -1)
                                          ]))]),
                                          _: 1
                                        }))
                                  ])
                                ]),
                                _createElementVNode("th", {
                                  class: "sortable-header",
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (sortMemberData('birthDate')))
                                }, [
                                  _createElementVNode("div", _hoisted_10, [
                                    _cache[17] || (_cache[17] = _createElementVNode("span", null, "생년월일", -1)),
                                    (memberSortState.value.column === 'birthDate')
                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 0,
                                          size: "small",
                                          class: "sort-icon"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(memberSortState.value.direction === 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down'), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 1,
                                          size: "small",
                                          class: "sort-icon inactive"
                                        }, {
                                          default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                                            _createTextVNode(" mdi-unfold-more-horizontal ", -1)
                                          ]))]),
                                          _: 1
                                        }))
                                  ])
                                ]),
                                _createElementVNode("th", {
                                  class: "sortable-header",
                                  onClick: _cache[6] || (_cache[6] = ($event: any) => (sortMemberData('gender')))
                                }, [
                                  _createElementVNode("div", _hoisted_11, [
                                    _cache[19] || (_cache[19] = _createElementVNode("span", null, "성별", -1)),
                                    (memberSortState.value.column === 'gender')
                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 0,
                                          size: "small",
                                          class: "sort-icon"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(memberSortState.value.direction === 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down'), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 1,
                                          size: "small",
                                          class: "sort-icon inactive"
                                        }, {
                                          default: _withCtx(() => [...(_cache[18] || (_cache[18] = [
                                            _createTextVNode(" mdi-unfold-more-horizontal ", -1)
                                          ]))]),
                                          _: 1
                                        }))
                                  ])
                                ]),
                                _createElementVNode("th", {
                                  class: "sortable-header",
                                  onClick: _cache[7] || (_cache[7] = ($event: any) => (sortMemberData('qualification')))
                                }, [
                                  _createElementVNode("div", _hoisted_12, [
                                    _cache[21] || (_cache[21] = _createElementVNode("span", null, "보유자격증", -1)),
                                    (memberSortState.value.column === 'qualification')
                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 0,
                                          size: "small",
                                          class: "sort-icon"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(memberSortState.value.direction === 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down'), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 1,
                                          size: "small",
                                          class: "sort-icon inactive"
                                        }, {
                                          default: _withCtx(() => [...(_cache[20] || (_cache[20] = [
                                            _createTextVNode(" mdi-unfold-more-horizontal ", -1)
                                          ]))]),
                                          _: 1
                                        }))
                                  ])
                                ]),
                                _createElementVNode("th", {
                                  class: "sortable-header",
                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (sortMemberData('workPeriod')))
                                }, [
                                  _createElementVNode("div", _hoisted_13, [
                                    _cache[23] || (_cache[23] = _createElementVNode("span", null, "입사일", -1)),
                                    (memberSortState.value.column === 'workPeriod')
                                      ? (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 0,
                                          size: "small",
                                          class: "sort-icon"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(memberSortState.value.direction === 'asc' ? 'mdi-arrow-up' : 'mdi-arrow-down'), 1)
                                          ]),
                                          _: 1
                                        }))
                                      : (_openBlock(), _createBlock(_component_v_icon, {
                                          key: 1,
                                          size: "small",
                                          class: "sort-icon inactive"
                                        }, {
                                          default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                                            _createTextVNode(" mdi-unfold-more-horizontal ", -1)
                                          ]))]),
                                          _: 1
                                        }))
                                  ])
                                ]),
                                _cache[24] || (_cache[24] = _createElementVNode("th", null, [
                                  _createElementVNode("span", null, "퇴사일")
                                ], -1))
                              ])
                            ]),
                            _createElementVNode("tbody", null, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredMemberData.value, (member, index) => {
                                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                                  _createElementVNode("td", null, _toDisplayString(member.name), 1),
                                  _createElementVNode("td", null, _toDisplayString(member.birthDate), 1),
                                  _createElementVNode("td", null, _toDisplayString(member.gender), 1),
                                  _createElementVNode("td", null, _toDisplayString(member.qualification), 1),
                                  _createElementVNode("td", null, _toDisplayString(splitDateRange(member.workPeriod).startDate), 1),
                                  _createElementVNode("td", null, _toDisplayString(splitDateRange(member.workPeriod).endDate), 1)
                                ]))
                              }), 128))
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "grey",
                  variant: "text",
                  onClick: closeDialog
                }, {
                  default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                    _createTextVNode(" 취소 ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "#1e3a8a",
                  variant: "flat",
                  disabled: !memberFile.value,
                  loading: isUploadingMember.value,
                  onClick: uploadMemberFile
                }, {
                  default: _withCtx(() => [...(_cache[26] || (_cache[26] = [
                    _createTextVNode(" 업로드 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["disabled", "loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model-value"]),
    _createVNode(_component_v_dialog, {
      modelValue: showComparisonDialog.value,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((showComparisonDialog).value = $event)),
      "max-width": "1200px",
      "content-class": "comparison-dialog-wrapper"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "comparison-card" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "comparison-header" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  color: "white",
                  class: "mr-2"
                }, {
                  default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
                    _createTextVNode("mdi-compare-horizontal", -1)
                  ]))]),
                  _: 1
                }),
                _cache[28] || (_cache[28] = _createTextVNode(" 변경사항 비교 ", -1))
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_text, { class: "comparison-content" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(_component_v_chip, {
                    color: "#1e3a8a",
                    variant: "tonal",
                    class: "mr-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { start: "" }, {
                        default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
                          _createTextVNode("mdi-plus-circle", -1)
                        ]))]),
                        _: 1
                      }),
                      _createTextVNode(" 추가: " + _toDisplayString(comparisonData.value.summary.added) + "명 ", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_chip, {
                    color: "#1e3a8a",
                    variant: "tonal",
                    class: "mr-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { start: "" }, {
                        default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
                          _createTextVNode("mdi-pencil", -1)
                        ]))]),
                        _: 1
                      }),
                      _createTextVNode(" 수정: " + _toDisplayString(comparisonData.value.summary.modified) + "명 ", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_chip, {
                    color: "#1e3a8a",
                    variant: "tonal",
                    class: "mr-2"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { start: "" }, {
                        default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
                          _createTextVNode("mdi-minus-circle", -1)
                        ]))]),
                        _: 1
                      }),
                      _createTextVNode(" 삭제: " + _toDisplayString(comparisonData.value.summary.deleted) + "명 ", 1)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_v_chip, {
                    color: "#1e3a8a",
                    variant: "tonal"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_v_icon, { start: "" }, {
                        default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
                          _createTextVNode("mdi-check-circle", -1)
                        ]))]),
                        _: 1
                      }),
                      _createTextVNode(" 변경없음: " + _toDisplayString(comparisonData.value.summary.unchanged) + "명 ", 1)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_15, [
                  _createVNode(_component_v_table, {
                    class: "comparison-table",
                    "fixed-header": "",
                    density: "compact"
                  }, {
                    default: _withCtx(() => [
                      _cache[39] || (_cache[39] = _createElementVNode("thead", null, [
                        _createElementVNode("tr", null, [
                          _createElementVNode("th", { class: "status-column" }, "상태"),
                          _createElementVNode("th", null, "성명"),
                          _createElementVNode("th", null, "생년월일"),
                          _createElementVNode("th", null, "성별"),
                          _createElementVNode("th", null, "보유자격증"),
                          _createElementVNode("th", null, "근무기간")
                        ])
                      ], -1)),
                      _createElementVNode("tbody", null, [
                        (comparisonData.value.comparison.length === 0)
                          ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [...(_cache[33] || (_cache[33] = [
                              _createElementVNode("td", {
                                colspan: "6",
                                class: "text-center text-grey"
                              }, "비교할 데이터가 없습니다", -1)
                            ]))]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(comparisonData.value.comparison, (item, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: index,
                            class: _normalizeClass(`row-${item.status}`)
                          }, [
                            _createElementVNode("td", _hoisted_17, [
                              _createVNode(_component_v_chip, {
                                color: getStatusColor(item.status),
                                size: "small",
                                variant: "flat",
                                class: "status-chip"
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_icon, {
                                    start: "",
                                    size: "small"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(getStatusIcon(item.status)), 1)
                                    ]),
                                    _: 2
                                  }, 1024),
                                  _createTextVNode(" " + _toDisplayString(getStatusText(item.status)), 1)
                                ]),
                                _: 2
                              }, 1032, ["color"])
                            ]),
                            _createElementVNode("td", {
                              class: _normalizeClass({ 'changed-cell': item.changes?.name })
                            }, [
                              _createTextVNode(_toDisplayString(item.name) + " ", 1),
                              (item.changes?.name)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                    _createElementVNode("small", _hoisted_19, _toDisplayString(item.changes.name.old), 1),
                                    _createVNode(_component_v_icon, {
                                      size: "x-small",
                                      class: "mx-1"
                                    }, {
                                      default: _withCtx(() => [...(_cache[34] || (_cache[34] = [
                                        _createTextVNode("mdi-arrow-right", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _createElementVNode("small", _hoisted_20, _toDisplayString(item.changes.name.new), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2),
                            _createElementVNode("td", {
                              class: _normalizeClass({ 'changed-cell': item.changes?.birthDate })
                            }, [
                              _createTextVNode(_toDisplayString(item.birthDate) + " ", 1),
                              (item.changes?.birthDate)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                    _createElementVNode("small", _hoisted_22, _toDisplayString(item.changes.birthDate.old), 1),
                                    _createVNode(_component_v_icon, {
                                      size: "x-small",
                                      class: "mx-1"
                                    }, {
                                      default: _withCtx(() => [...(_cache[35] || (_cache[35] = [
                                        _createTextVNode("mdi-arrow-right", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _createElementVNode("small", _hoisted_23, _toDisplayString(item.changes.birthDate.new), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2),
                            _createElementVNode("td", {
                              class: _normalizeClass({ 'changed-cell': item.changes?.gender })
                            }, [
                              _createTextVNode(_toDisplayString(item.gender) + " ", 1),
                              (item.changes?.gender)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                    _createElementVNode("small", _hoisted_25, _toDisplayString(item.changes.gender.old), 1),
                                    _createVNode(_component_v_icon, {
                                      size: "x-small",
                                      class: "mx-1"
                                    }, {
                                      default: _withCtx(() => [...(_cache[36] || (_cache[36] = [
                                        _createTextVNode("mdi-arrow-right", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _createElementVNode("small", _hoisted_26, _toDisplayString(item.changes.gender.new), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2),
                            _createElementVNode("td", {
                              class: _normalizeClass({ 'changed-cell': item.changes?.qualification })
                            }, [
                              _createTextVNode(_toDisplayString(item.qualification) + " ", 1),
                              (item.changes?.qualification)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                    _createElementVNode("small", _hoisted_28, _toDisplayString(item.changes.qualification.old), 1),
                                    _createVNode(_component_v_icon, {
                                      size: "x-small",
                                      class: "mx-1"
                                    }, {
                                      default: _withCtx(() => [...(_cache[37] || (_cache[37] = [
                                        _createTextVNode("mdi-arrow-right", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _createElementVNode("small", _hoisted_29, _toDisplayString(item.changes.qualification.new), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2),
                            _createElementVNode("td", {
                              class: _normalizeClass({ 'changed-cell': item.changes?.workPeriod })
                            }, [
                              _createTextVNode(_toDisplayString(item.workPeriod) + " ", 1),
                              (item.changes?.workPeriod)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                    _createElementVNode("small", _hoisted_31, _toDisplayString(item.changes.workPeriod.old), 1),
                                    _createVNode(_component_v_icon, {
                                      size: "x-small",
                                      class: "mx-1"
                                    }, {
                                      default: _withCtx(() => [...(_cache[38] || (_cache[38] = [
                                        _createTextVNode("mdi-arrow-right", -1)
                                      ]))]),
                                      _: 1
                                    }),
                                    _createElementVNode("small", _hoisted_32, _toDisplayString(item.changes.workPeriod.new), 1)
                                  ]))
                                : _createCommentVNode("", true)
                            ], 2)
                          ], 2))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  })
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "grey",
                  variant: "text",
                  onClick: cancelUpload
                }, {
                  default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                    _createTextVNode(" 취소 ", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  color: "#1e3a8a",
                  variant: "flat",
                  loading: isUploadingMember.value,
                  disabled: !memberFile.value,
                  onClick: confirmUpload
                }, {
                  default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                    _createTextVNode(" 업로드 실행 ", -1)
                  ]))]),
                  _: 1
                }, 8, ["loading", "disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})